import * as classnames from 'classnames'
import * as React from 'react'

import { MakeSearchLink } from '../../../common/utils/location/types'
import SearchIcon from '../icons/search'
import SearchForm from '../searchBar/searchBarForm'
import Input from '../searchBar/searchBarInput'

import * as styles from './compactSearchBar.module.css'

interface IProps extends React.FormHTMLAttributes<HTMLFormElement> {
  className?: string
  makeSearchLink: MakeSearchLink
  noBorder?: boolean
}

const CompactSearchBar = ({ className, makeSearchLink, noBorder }: IProps) => {
  const nextClassName = classnames(styles.root, className, {
    [styles.noBorder]: !!noBorder
  })

  return (
    <div className={nextClassName}>
      <SearchForm makeSearchLink={makeSearchLink}>
        <div className={styles.searchInlineElement} />
        <div className={styles.form}>
          <div className={styles.inputWrapper}>
            <Input
              className={styles.input}
              name="term"
              placeholder="Search"
              role="search"
            />
          </div>
          <button className={styles.searchButton} type="submit">
            <SearchIcon title="search" />
          </button>
        </div>
      </SearchForm>
    </div>
  )
}

export default CompactSearchBar
